import user from 'btm-user-manager'; //eslint-disable-line import/no-extraneous-dependencies
import disneyOneIdWrapper from 'disneyOneIdWrapper'; //eslint-disable-line import/no-unresolved, import/extensions
import * as bamDeepGet from 'bam-deep-get';

// currently not used
function enableButtons() {
    $('#login-link').on('click', () => {
        disneyOneIdWrapper.disneyIdService.launchLogin();
    });
}

/**
* Event Listeners
**/
disneyOneIdWrapper.disneyIdService.on('login', (guest) => {
    $('#login-link').css('display', 'none');

    const swid = (guest.profile && guest.profile.swid) ? guest.profile.swid : '';

    return user.external.login(guest.token.id_token, swid).then(() => {
        user.subscription.getSubscriptions().then((subs) => {
            return user.subscription.setSubscriptionsInLocalStorage(subs, swid);
        }).then(() => {
            if (window.disneyIDLoginSuccessUrl) {
                window.location = window.disneyIDLoginSuccessUrl;
            } else {
                window.location.reload();
            }
        });
    }).catch(disneyOneIdWrapper.handleBreachErrors);
});

disneyOneIdWrapper.init().then((data) => {

    const token = bamDeepGet.deepGet(data, 'guest.token.id_token', '');
    const swid = bamDeepGet.deepGet(data, 'guest.profile.swid', '');
    user.external.syncExternalToBtm(data.loggedIn, token, swid).then(() => {

        // Initialize links
        if (data.loggedIn) {
            window.isLoggedIn = true;
            // currently not used
            $('#loading-label').css('display', 'none');
            $('#subscriptions-link').css('display', 'block');
        } else {
            $('#loading-label').css('display', 'none');
            $('#login-link').css('display', 'block');
        }
        enableButtons();
    });
});
